import {request} from "../../../utils/apiUtils";
import {URL_API} from "../../../url.config";

let FeeController = {

    create: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/fee/create`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    list: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/fee/list`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    edit: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/fee/edit`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    detail: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/fee/detail/${id}`,
            method: 'GET'
        }, callback)
    },
    delete: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/fee/delete/${id}`,
            method: 'GET'
        }, callback)
    }
}

export default FeeController
